import React, {useState} from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

// Modal for doctor to select which referrals he executed before invoicing in the end of the visit
const VisitExecutedReferrals = ({show, setShow, referralData, callback}) => {
    const [selectedBarcodes, setSelectedBarcodes] = useState([]);

    const onSubmit = () => {
        setShow(false);
        callback(selectedBarcodes);
    }

    return (
        <React.Fragment>
            <Modal show={show} onHide={() => setShow(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Εκτελεσμένα Παραπεμπτικά</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Παρακαλώ επιλέξτε πια παραπεμπτικά έχετε εκτελέσει στον παρακάτω πίνακα, έτσι ώστε να συμπληρωθούν αυτόματα στο παραστατικό που θα εκδώσετε.
                    Οι επιλογές είναι προαιρετικές, μπορείτε να μεταβάλλετε τα δεδομένα πρωτού εκδώσετε.
                    {referralData && (
                        <React.Fragment>
                            <table className={"simpleClassicTable mt-2"}>
                                <colgroup>
                                    <col span={1} style={{width: "70%"}}></col>
                                    <col span={1} style={{width: "30%"}}></col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>Αρ. Παραπεμπτικού</th>
                                    <th>Επιλογή</th>
                                </tr>
                                </thead>
                                <tbody>
                                {referralData.map((ref, idx) => (
                                    <tr key={`ver-${idx}`}>
                                        <td>{ref.referralId}</td>
                                        <td style={{zoom: 1.3}}>
                                            <input type={"checkbox"} onChange={(e) => {
                                                if (e.target.checked) {
                                                    setSelectedBarcodes([...selectedBarcodes, ref.referralId]);
                                                } else {
                                                    setSelectedBarcodes(selectedBarcodes.filter((el) => el !== ref.referralId));
                                                }
                                            }} checked={selectedBarcodes.includes(ref.referralId)} />
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </React.Fragment>
                    )}
                    Αν δεν έχετε εκτελέσει κάποιο παραπεμπτικό, απλά αφήστε κενές τις επιλογές παραπάνω και πατήστε "Ολοκλήρωση επίσκεψης".
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => onSubmit()}>
                        Ολοκλήρωση επίσκεψης {selectedBarcodes.length > 0 && <React.Fragment>και έκδοση παραστατικού</React.Fragment>}
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default VisitExecutedReferrals
